import { Component } from "react";

export const KEY_EVENT_DOWN = "keydown";
export const KEY_EVENT_PRESS = "keypress";
export const KEY_EVENT_UP = "keyup";

export const KEY_CODE_ESC = 27;
export const KEY_CODE_ENTER = 13;
export const KEY_CODE_ARROW_UP = 38;
export const KEY_CODE_ARROW_DOWN = 40;

export class KeyHandler extends Component<{ keyCode: any; onKeyHandle: any }> {
  static defaultProps = {
    keyEventName: KEY_EVENT_UP,
  };

  constructor(props: any) {
    super(props);
    this.handleKey = this.handleKey.bind(this);
  }

  componentDidMount() {
    const { keyEventName }: any = this.props;
    document.addEventListener(keyEventName, this.handleKey, false);
  }

  componentWillUnmount() {
    const { keyEventName }: any = this.props;
    document.removeEventListener(keyEventName, this.handleKey, false);
  }

  shouldComponentUpdate() {
    return false;
  }

  handleKey(event: any) {
    const { keyCode, onKeyHandle }: any = this.props;
    if (event.keyCode === keyCode) {
      onKeyHandle(event);
    }
  }

  render() {
    return null;
  }
}
